export const fixFemaleOrMale = (
  gender: string | undefined
): "female" | "male" => {
  if (gender === "female" || gender === "male") {
    return gender;
  }

  return gender === "women" || gender === "kids" || !gender ? "female" : "male";
};
